// extracted by mini-css-extract-plugin
export var container = "_bf-0";
export var icon = "_bf-1";
export var text = "_bf-2";